export default [
  /**
   * @query.type
   * @query.id
   */
  {path: '/consult/rules', component: () => import('../page/consult/rules')},

  /**
   * 图文咨询
   * 第一页
   * @query.id
   * @query.type [pic,team,renewal]
   * @query.serverId
   */
  {path: '/consult/v2/1', component: () => import('../page/consult/v2/first')},
  /**
   * 图文咨询
   * 第二页
   * @query.id
   * @query.type [pic,team,renewal]
   */
  {path: '/consult/v2/2', component: () => import('../page/consult/v2/second')},

  /**
   * 医生列表
   * @description 按gbDeptCode查询
   */
  {path: '/consult/doc/list', component: () => import('../page/consult/doc/list.vue')}
]



// WEBPACK FOOTER //
// ./src/router/consult.js